import { render } from "./SaleEdit.vue?vue&type=template&id=10464846&scoped=true"
import script from "./SaleEdit.vue?vue&type=script&lang=js"
export * from "./SaleEdit.vue?vue&type=script&lang=js"

import "./SaleEdit.vue?vue&type=style&index=0&id=10464846&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10464846"]])

export default __exports__